<app-crudbar-nav #crudbar [title]="title" [visible]="false" (onReady)="doComReady($event,'crudbar-nav')">
</app-crudbar-nav>

<mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start"
  class="h-full"
  style="vertical-align: top;" animationDuration="0ms" dynamicHeight
  (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="瀏覽">
    <div class="border-2 border-red-300">
      <app-jkaggrid #myGrid  [columnDefs]="srv.columnDefs"
        (afterGridReadyAg)="afterGridReady($event)" (rowClicked)="agRowClicked($event)"
        (rowSelected)="agRowSelected($event)" (onInsert)="doUIInsert($event)"
        (onDelete)="doUIDelete($event)"></app-jkaggrid>

    </div>
  </mat-tab>
  <mat-tab #myTabDetail label="明細">
    <!-- <app-mtrmb-tabedit [srv]="srv"></app-mtrmb-tabedit> -->
    <div style="max-height: 400px; overflow-y: auto;">
          <app-jktext  label="公司電話(一)" [value]="item.MB023"     >
    </app-jktext>
    <app-jktext  label="個人郵遞區號" [value]="item.MB017"     >
    </app-jktext>
    <app-jktext  label="個人網址" [value]="item.MB018"     >
    </app-jktext>
    <app-jktext  label="照片檔名" [value]="item.MB019"     >
    </app-jktext>
    <app-jktextarea  height="250px"
 label="備註" #MB020Com  id="MB020"  [(value)]="item.MB020" [readonly]="true"     >
    </app-jktextarea>
    <app-jktext  label="公司地址" [value]="item.MB021"     >
    </app-jktext>
    <app-jktext  label="公司郵遞區號" [value]="item.MB022"     >
    </app-jktext>
    <app-jktext  label="個人地址" [value]="item.MB016"     >
    </app-jktext>
    <app-jktext  label="公司傳真號碼" [value]="item.MB024"     >
    </app-jktext>
    <app-jktext  label="公司E-MAIL" [value]="item.MB025"     >
    </app-jktext>
    <app-jktext  label="暱稱" [value]="item.MB026"     >
    </app-jktext>
    <app-jktext  label="客戶代號" [value]="item.MB027"     >
    </app-jktext>
    <app-jktext  label="廠商代號" [value]="item.MB028"     >
    </app-jktext>
    <app-jktext  label="部門名稱" [value]="item.MB029"     >
    </app-jktext>
    <app-jktextarea  height="250px"
 label="附註" #MB030Com  id="MB030"  [(value)]="item.MB030" [readonly]="true"     >
    </app-jktextarea>
    <app-jktext  label="流水號" [value]="item.MB001"     >
    </app-jktext>
    <app-jktext  label="個人電話(二)" [value]="item.MB008"     >
    </app-jktext>
    <app-jktext  label="擁有者" [value]="item.MB002"     >
    </app-jktext>
    <app-jktext  label="姓名" [value]="item.MB003"     >
    </app-jktext>
    <app-jktext  label="職務" [value]="item.MB004"     >
    </app-jktext>
    <app-jkcombobox  label="性別" #MB005Com  id="MB005"  [(value)]="item.MB005" [items]="srv.MtrMb005List"  [readonly]="true"     >
    </app-jkcombobox>
    <app-jktext  label="公司" [value]="item.MB006"     >
    </app-jktext>
    <app-jktext  label="個人電話(一)" [value]="item.MB007"     >
    </app-jktext>
    <app-jkdatefield  label="生日" #MB015Com  id="MB015"  [(value)]="item.MB015" [readonly]="true"     >
    </app-jkdatefield>
    <app-jktext  label="手機" [value]="item.MB009"     >
    </app-jktext>
    <app-jktext  label="個人傳真號碼" [value]="item.MB010"     >
    </app-jktext>
    <app-jktext  label="個人E-MAIL" [value]="item.MB011"     >
    </app-jktext>
    <app-jktext  label="部門別" [value]="item.MB012"     >
    </app-jktext>
    <app-jktext  label="通路別" [value]="item.MB013"     >
    </app-jktext>
    <app-jktext  label="地區別" [value]="item.MB014"     >
    </app-jktext>

    </div>
  </mat-tab>
  <mat-tab #myTabAdvance label="進階">

  </mat-tab>
</mat-tab-group>
